// @flow
import {observable, action} from 'mobx'
import {notification} from 'antd'
import {Api} from './api'
import {AlgoStore} from './algo'
import {BacktestStore} from './backtest'
import {StockFilter} from './stockFilter'
import {PaperTrading} from './paperTrading'
import {UserStore} from './user'
import {IbStore} from './ib'
import {Payment} from './payment'
import {Signal} from './signal'
import {Symbols} from './symbols'
import {Analysis} from './analysis'
import {Auth} from './auth'
import {Signup} from './signup'
import {Subscription} from './subscription'
import {Public} from './public'
import {Permissions} from './permissions'

export class Store {
  api: Api
  algo: AlgoStore
  backtest: BacktestStore
  stockFilter: StockFilter
  paperTrading: PaperTrading
  user: UserStore
  ib: IbStore
  payment: Payment
  signal: Signal
  symbols: Symbols
  analysis: Analysis
  auth: Auth
  signup: Signup
  subscription: Subscription
  public: Public
  permissions: Permissions

  @observable settings = {
    loaded: false
  }
  @observable redirect = {}

  constructor() {
    this.api = new Api(this)
    this.algo = new AlgoStore(this, this.api)
    this.backtest = new BacktestStore(this, this.api)
    this.stockFilter = new StockFilter(this, this.api)
    this.paperTrading = new PaperTrading(this, this.api)
    this.user = new UserStore(this, this.api)
    this.ib = new IbStore(this, this.api)
    this.payment = new Payment(this)
    this.signal = new Signal(this)
    this.symbols = new Symbols(this)
    this.analysis = new Analysis(this, this.api)
    this.auth = new Auth(this)
    this.signup = new Signup(this)
    this.subscription = new Subscription(this, this.api)
    this.public = new Public(this, this.api)
    this.permissions = new Permissions(this, this.api)
  }

  @action async getSettings() {
    try {
      const {settings} = await this.api.request('sys/settings', 'get')
      settings.map(row => {
        if (row.value === 'true') {
          settings[row.ident] = true
        } else if (row.value === 'false') {
          settings[row.ident] = false
        } else {
          settings[row.ident] = row.value
        }
      })
      this.settings = {loaded:true, ...settings}
    } catch(e) {
      notification['error']({
        message: 'Failed to load settings',
        description: e.message || 'Unknown error'
      })
    }
  }

  @action redirectTo(redirect: {[key: string]: string}) {
    this.redirect = redirect
  }

  @action clearRedirect() {
    this.redirect = {}
  }
}
